import React from 'react';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NavHeaderSkeleton } from './NavHeaderSkeleton';

import { useHistory } from 'react-router-dom';
import * as actionCreator from "../../actions";
import { IconCactusLogoHorizontal } from '../../assets/icons/IconCactusLogoHorizontal';
import LanguageSwitch from '../LanguageSwitch/LanguageSwitch';
import { getFullName } from '../../models/User';

interface NavHeaderProps {
    onMenuToggle?: () => void;
};

const NavHeader: React.FC<NavHeaderProps> = (props: NavHeaderProps) => {

    const [t] = useTranslation();

    let history = useHistory()
    const dispatch = useDispatch();

    const { status: showSubmenu } = useSelector( (store: any) => store.headerSubmenuReducer )

    const { user, isLoading } = useSelector( (store: any) => store.authReducer )

    const initials = user
        ? ((user.name?.[0] ?? '') + (user.last_name?.[0] ?? '')).toUpperCase()
        : '';

    const _renderSubmenu = () => {
        const fullName = getFullName(user);
        const role = user?.rol?.[0] ?? '';

        return (
            <div
                className="navbar__user__submenu"
                onMouseLeave={ () => dispatch( actionCreator.headerSubmenuChangeValue( false ) ) }
            >
                <div className="navbar__user__submenu__header">
                    <div className="navbar__user__submenu__avatar">{initials}</div>
                    <div className="navbar__user__submenu__info">
                        <div className="navbar__user__submenu__name">{fullName}</div>
                        { role && <div className="navbar__user__submenu__role">{role}</div> }
                    </div>
                </div>
                <div className="navbar__user__submenu__divider" />
                <ul>
                    <li onClick={ (e) => {
                        e.stopPropagation();
                        dispatch( actionCreator.headerSubmenuChangeValue( false ) );
                        history.push('/profile');
                    }}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                            <circle cx="12" cy="7" r="4"/>
                        </svg>
                        {t('Profile')}
                    </li>
                    <li className="navbar__user__submenu__item--danger" onClick={ (e) => {
                        e.stopPropagation();
                        dispatch( actionCreator.authLogout() );
                    }}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                            <polyline points="16 17 21 12 16 7"/>
                            <line x1="21" y1="12" x2="9" y2="12"/>
                        </svg>
                        {t('Logout')}
                    </li>
                </ul>
            </div>
        )
    }

    const _renderUserInfo = () => {
        if (isLoading) {
            return (
                <NavHeaderSkeleton />
            )
        }
        return (
            <>
                <div><strong>{ user?.name }</strong></div>
                <div className="navbar__user__email">{ user?.email  }</div>
            </>
        )
    }

    return(
        <nav className='navbar'
            onMouseLeave={ () => dispatch( actionCreator.headerSubmenuChangeValue( false ) )}
        >
            <div className='navbar__left'>
                <button
                    className='navbar__hamburger'
                    onClick={props.onMenuToggle}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>
            <div className='navbar__logo'>
                <Link to='/dashboard'>
                    <IconCactusLogoHorizontal
                        class='fill-gray-light'
                    />
                </Link>
            </div>
            <div className='navbar__user'>
                <div
                    className='navbar__user__trigger pointer'
                    onClick={ () => dispatch( actionCreator.headerSubmenuChangeValue( !showSubmenu ) ) }
                >
                    { _renderUserInfo() }
                </div>
                { showSubmenu && _renderSubmenu() }
                <div className='navbar__user__lang_switch'>
                    <LanguageSwitch />
                </div>
            </div>
        </nav>
    );


};


export default React.memo(NavHeader);
